import { useSelector } from 'react-redux'

import EntitiesSelector from './EntitiesSelector'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { InternshipDurationTypes } from '../../../utils/constants'

const DurationTypesSelector = ({ className = '', disabled, multiple = 'default', style = {}, values, onChange }) => {
  const t = useSelector(selectTranslate)

  const durationTypeOptions = [
    { value: InternshipDurationTypes.DAY, label: t('internship_request.duration.units.day') },
    { value: InternshipDurationTypes.WEEK, label: t('internship_request.duration.units.week') },
    { value: InternshipDurationTypes.HOUR, label: t('internship_request.duration.units.hour') }
  ]

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={durationTypeOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default DurationTypesSelector
